import "./App.css";
import Layout from "./Components/UI/Layout";
import { Route, Routes, Navigate } from "react-router-dom";

import "./fonts/SimplerPro_V3-Black.ttf";
import "./fonts/SimplerPro_V3-Bold.ttf";
import "./fonts/SimplerPro_V3-Light.ttf";
import "./fonts/SimplerPro_V3-Regular.ttf";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          exact
          element={<Navigate to="default" replace={true} />}
        />
        <Route path="/:stationName" element={<Layout />} />
      </Routes>
    </div>
  );
}

export default App;
